import styled from 'styled-components'

export const Container = styled.div`
  max-width: 100%;
  width: 720px;
  margin: auto;
  padding: 16px;
`

export const Divider = styled.div`
  height: 0px;
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
  border-bottom: 1px solid #cdcdcd;
`

export const CircleBtn = styled.button`
  height: 30px;
  width: 30px;
  border: none;
  outline: none;
  border-radius: 15px;
  cursor: pointer;
  background-color: #cecedc;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: #b4b4c0;
  }
`
